//#region src/constants/sanitization.ts
const ALLOWED_HTML_ATTRIBUTES = [
	"href",
	"name",
	"target",
	"title",
	"class",
	"id",
	"style"
];
const ALLOWED_HTML_TAGS = [
	"p",
	"strong",
	"b",
	"code",
	"a",
	"br",
	"i",
	"ul",
	"li",
	"em",
	"small",
	"details",
	"summary",
	"mark"
];

//#endregion
export { ALLOWED_HTML_TAGS as n, ALLOWED_HTML_ATTRIBUTES as t };
//# sourceMappingURL=sanitization.mjs.map